import { formatMoney } from "utilities/datalist/datalist-sort-utilities";
import { DateFormats, DateUtil } from "utilities/date-utilities";
import HTMLCode from "../HTMLCode";
import BooleanView from "./BooleanView";

export type AppPropertyType = 'date' | 'datetime' | 'time' | 'string' | 'number' | 'money' | 'wight' | 'note' | 'bool';

type PropertyViewValuePropsType = {
    value?: any,
    propertyType?: AppPropertyType;
}

const PropertyViewValue = (props: PropertyViewValuePropsType) => {
    let value = props.value;
    if (Array.isArray(props.value) && props.value.length) {
        value = (
            <ul>
                {props.value.map(i => {
                    return <li key={i?.toString()}>- {i?.toString() || '-'}</li>;
                })}
            </ul>
        );
    }

    if(props.propertyType) {
        switch(props.propertyType) {
            case 'money': 
                return <span>{formatMoney(props.value)} <HTMLCode code="euro" /></span>
            case 'wight': 
                return <span>{formatMoney(props.value)} kg</span>
            case 'note': 
                return props.value
                    ? <div className="whitespace-pre-wrap p-2 bg-neutral-100 dark:bg-neutral-800">{props.value}</div>
                    : <span>-</span>;
            case 'bool': 
                return <BooleanView value={props.value} />
            case 'datetime':
                return <span>{DateUtil.format(new Date(props.value), DateFormats.LONG)}</span>
            case 'date':
                return <span>{DateUtil.format(new Date(props.value), DateFormats.SHORT)}</span>
            default: 
                return props.value;
        }
    }

    if (typeof props.value == 'boolean') {
        value = <BooleanView value={props.value} />
    }

    if(value === null || value === undefined || value === '' || value.length === 0) {
        value = <span>-</span>;
    }

    return value;
};

export default PropertyViewValue;
